//frontend/src/context/SocketContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SOCKET_URL = 'https://crm.aunimeda.com';
const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
   const [socket, setSocket] = useState(null);
   const [isConnected, setIsConnected] = useState(false);

   useEffect(() => {
       const newSocket = io(SOCKET_URL, {
           withCredentials: true,
           transports: ['websocket'],
           upgrade: false,
           auth: {
               token: localStorage.getItem('token')
           },
           reconnection: true,
           reconnectionAttempts: 5,
           reconnectionDelay: 1000,
           timeout: 10000
       });

       newSocket.on('connect', () => {
           console.log('Socket connected');
           setIsConnected(true);
       });

       newSocket.on('disconnect', () => {
           console.log('Socket disconnected');
           setIsConnected(false);
       });

       newSocket.on('connect_error', (error) => {
           console.error('Socket connection error:', error);
           setIsConnected(false);
       });

       newSocket.on('error', (error) => {
           console.error('Socket error:', error);
       });

       setSocket(newSocket);

       return () => {
           if (newSocket) {
               newSocket.off('connect');
               newSocket.off('disconnect');
               newSocket.off('connect_error');
               newSocket.off('error');
               newSocket.close();
           }
       };
   }, []);

   const connect = () => {
       if (socket) {
           socket.connect();
       }
   };

   const disconnect = () => {
       if (socket) {
           socket.disconnect();
       }
   };

   const emit = (eventName, data) => {
       if (socket && isConnected) {
           socket.emit(eventName, data);
       }
   };

   const value = {
       socket,
       isConnected,
       connect,
       disconnect,
       emit,
       on: (event, callback) => socket?.on(event, callback),
       off: (event, callback) => socket?.off(event, callback)
   };

   return (
       <SocketContext.Provider value={value}>
           {children}
       </SocketContext.Provider>
   );
};

export const useSocket = () => {
   const context = useContext(SocketContext);
   if (!context) {
       throw new Error('useSocket must be used within a SocketProvider');
   }
   return context;
};

export default SocketContext;